export default {"src":"/_next/static/media/HD.9c31d6f1.svg","height":18,"width":18};